import type { FC } from 'react'
import type { ERC20Names } from '@g4g/wallet-modal/types'
import AttentionBox from '@g4g/ui/src/components/AttentionBox'
import CheckoutPaymentHodlAttention from './CheckoutPaymentHodlAttention'

const CheckoutPaymentAttention: FC<{
  loading: boolean
  paymentOption: ERC20Names
  error?: Error
  hasEnoughForGas?: boolean
}> = ({ loading, error, paymentOption, hasEnoughForGas }) => {
  return (
    <>
      {!loading && (
        <>
          {error ? (
            <AttentionBox>
              Something went wrong when trying to estimate transaction fees
            </AttentionBox>
          ) : (
            <>
              {!hasEnoughForGas && (
                <AttentionBox>Not enough MATIC to complete the transaction</AttentionBox>
              )}
              {/* Display info about locked prps being burned if necessary */}
              {paymentOption === 'Purpose' && hasEnoughForGas && <CheckoutPaymentHodlAttention />}
            </>
          )}
        </>
      )}
    </>
  )
}

export default CheckoutPaymentAttention
